export default {
	tabs: ["Deposito", "Cronologia"],
	History: {
		tabs: ["Revisione", "Successo", "Rifiuta"]
	},
	AccountAmount: "Importo dell'Account",
	ContactCustomerService: "Contatta il Servizio Clienti",
	NoCustomerService: "Servizio Clienti Occupato",
	tips: "Cortesemente invia la valutazione precedente prima di procedere con la successiva valutazione"
};
